module.exports = __webpack_public_path__ + "img/0a03684.jpg";